export const PROFILE_PATH = '/profile';
export const EDIT_CONTACT_PATH = '/profile/edit';
export const EDIT_NOTIFICATIONS_PATH = '/profile/edit-notifications';
export const EDIT_PASSWORD_PATH = '/profile/change-password';

export const DISPOSE_PROFILE_STORE = 'DISPOSE_PROFILE_STORE';

export const PROFILE_HISTORY_REQUEST = 'PROFILE_HISTORY_REQUEST';
export const PROFILE_HISTORY_SUCCESS = 'PROFILE_HISTORY_SUCCESS';

export const PROFILE_ORGANIZATIONS_REQUEST = 'PROFILE_ORGANIZATIONS_REQUEST';
export const PROFILE_ORGANIZATIONS_SUCCESS = 'PROFILE_ORGANIZATIONS_SUCCESS';
